import { Injectable } from "@angular/core";
import { SessionStorageService } from "ngx-webstorage";



export const Tenant: Record<string, string> = {
  ADMIN: 'ADMIN', // criado para fazer generalizações
  ALL: 'ALL', // criado para fazer generalizações
  NONE: 'NONE', // criado para fazer generalizações
};

@Injectable({
  providedIn: 'root',
})
export class TenantService {

  env: string = 'local';

  constructor(
    private sss: SessionStorageService
  ) {

  }



  init(): void {

    this.env = this.getActiveEnv();

    // if (!tenants.length) {
    //   this.fetchTenants();
    // }

  }

  getActiveTenant(): string {


    // verifica se tem x-app no sss. se tiver usa como tenant. se não tiver, pega o hostname e usa a primeira parte como tenant
    // isso para permitir dominios sem host especificos, como www.iorthopay.com
    const xApp = this.sss.retrieve('x-app');
    if (xApp && xApp.trim() !== '') {
      return xApp.toUpperCase();
    }

    let hostname = location.hostname;
    let host = hostname.split(".")[0];

    return host.toUpperCase();
  }

  getActiveEnv(): string {

    let hostname = location.hostname;
    let parts = hostname.split(".");
    let envi = 'prod';

    //xyz.dev.itek.dental
    //xyz.test.itek.dental
    //xyz.itek.dental
    //xyz.localhost.dental
    //xyz.localhost
    //www.iorthopay.com
    //iorthopay.angelalign.com.br
    if (hostname.toLowerCase().includes(".dev.")) {
      envi = 'dev';
    } else if (hostname.toLowerCase().includes("localhost")) {
      envi = 'local';
    } else {
      envi = 'prod';
    }


    // else if (parts.length == 4) {
    //   envi = parts[1];
    // } else if (parts.length <= 3) {
    //   if (parts[1].toLowerCase() !== "itek" || parts[2].toLowerCase() !== "dental") {
    //     envi = 'local';
    //   }
    // }

    return envi.toLowerCase();
  }

}
